import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.29 14.69 11 17.98l-1.29-1.29a1.001 1.001 0 1 0-1.42 1.41l2 2a1 1 0 0 0 1.42 0l4-4a1 1 0 1 0-1.42-1.41Zm4.13-5.87a7 7 0 0 0-13.36 1.9 4 4 0 0 0-.38 7.65 1 1 0 1 0 .64-1.87A2 2 0 0 1 4 14.6a2 2 0 0 1 2-2 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.6 1 1 0 0 0 .78.66 3 3 0 0 1 .24 5.84 1.008 1.008 0 0 0 .25 2h.25a5 5 0 0 0 .17-9.62v-.06Z" }, null, -1)
  ])))
}
export default { render: render }